import { loader } from 'graphql.macro'
import { makePublicGraphQLClient } from '../../utilities/graphqlClient'

export default async function signTermsAndCondition ({ variables }) {
  const schema = loader('./signTermsAndCondition.graphql')
  const response = await makePublicGraphQLClient().request(schema, {
    token: variables.token,
    signerName: variables.signerName,
    accepted: variables.accepted
  })
  return response.signTermsAndCondition
}
